<template>
  <main>
    <div class="flex">
      <div></div>
      <LocalePriority v-if="listLoaded"
                      :initial-list="list"
                      :currentLevel="currentLevel" />
      <div class="devices-count-wrapper">
        <span class="count">{{this.$t('message.spots.message.devices')}}: {{ totalDevicesNumber }}</span>
      </div>                
    </div>     
    <LocaleTable @setLevel="setLevel"
                 @unsetLevel="unsetLevel" 
                 @reloadDeviceCount="getAccountTotalDevicesNumber"/>
                 
  </main>
</template>

<script>
    import LocaleTable from '@views/locals/components/LocaleTable';
    import LocalePriority from '@views/locals/components/LocalePriority';


    export default {
        components: {
            LocaleTable,
            LocalePriority
        },        

        async created() {
          await this.getlocalPriority()
          await this.getAccountTotalDevicesNumber()
          await this.setDeviceTypes()
        },

        data() {
            return {
              currentLevel: 0,
              list: [],
              listLoaded: false,
            }
        },

        mixins: [],

        computed: {
          totalDevicesNumber() {
            return this.$store.state.devices.count
          }
        },

        methods: {
          setLevel(level) {
            this.currentLevel = level;
          },
          unsetLevel() {
            this.currentLevel = 0;
          },
          async getlocalPriority() {
            try {
              const list = await this.$api.localPriority.search(false);

              this.list = list.sort((priorityItemA, priorityItemB) => {
                return priorityItemA.level - priorityItemB.level
              }),

              this.listLoaded = true;
            } catch (error) {
              console.log(error)
            }
          },
          async getAccountTotalDevicesNumber() {
            try {
              await this.$loader.devices.getAccountTotalDevicesNumber()
            } catch (error) {
              console.log(error)
            }
          },
          async setDeviceTypes() {
            const deviceTypes = await this.$api.devices.types();

            this.$store.commit("DEVICES_SET_TYPE", deviceTypes);
          },
        },
    }
</script>

<style scoped>
.flex {
  display: grid;
  grid-template-columns: 300px auto 300px ;

  .devices-count-wrapper {
    justify-self: start;
    align-self: center;

    .count {
      color: #000000DE;
      font-weight: 600;
    }
  }
}
</style>
